import { HttpService } from '../../../common/http.service';
import { bulkCreateQACasesEndPoint } from '../../PPWB/api.endPoints';

export const bulkInitiateQA = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  try {
    const data = await HttpService.getInstance().postFiles(
      bulkCreateQACasesEndPoint(),
      formData,
    );
    return { data, error: null };
  } catch (error) {
    return { error, data: null };
  }
};
